import PropTypes from 'prop-types';
import React, { memo } from 'react';
import classNames from 'classnames';

import Checkbox from '../helpers/Checkbox';
import Button from '../helpers/Button';

import style from './style.module.css';

/**
 * Stateless component for search text input.
 *
 * @param props {Object}.
 */
const SearchInputComponent = ({
  disabled,
  onSearch,
  hasAccess,
  userName,
  onOnlyOwnerChange,
  onSearchingTermChange,
  searchingTerm,
  searchBy,
  onSearchBy,
}) => {
  const handleSearch = event => {
    if (disabled) {
      return;
    }

    if (event.key === 'Enter') {
      onSearch(event.key);
    }
  };
  const searchByUser = hasAccess ? (
    <Checkbox
      capitalizeLabel={false}
      id="onlyUserCheckbox"
      label={`Only ${userName}`}
      name="onlyOwner"
      onChange={onOnlyOwnerChange}
    />
  ) : null;

  return (
    <>
      <div className={classNames(style.search, 'input-group')}>
        <input
          className="form-control"
          id="searchingInput"
          name="searchingTerm"
          onChange={onSearchingTermChange}
          onKeyPress={handleSearch}
          placeholder="a search term..."
          value={searchingTerm}
        />
        <span className="input-group-btn">
          <Button className="btn-primary" disabled={disabled} onClick={onSearch}>
            <i aria-hidden="true" className="fa fa-search" /> Search
          </Button>
        </span>
      </div>
      <div className={style.options}>
        {searchByUser}
        <div className="checkbox-wrap">
          <input
            checked={searchBy === 'searchByWebsite'}
            id="searchByWebsiteCheckbox"
            name="searchByWebsite"
            onChange={onSearchBy}
            type="checkbox"
            value="searchByWebsite"
          />
          <label htmlFor="searchByWebsiteCheckbox">Search by Website</label>
        </div>
        <div className="checkbox-wrap">
          <input
            checked={searchBy === 'searchByPhone'}
            id="searchByPhoneCheckbox"
            name="searchByPhone"
            onChange={onSearchBy}
            type="checkbox"
            value="searchByPhone"
          />
          <label htmlFor="searchByPhoneCheckbox">Search by Phone Number</label>
        </div>
      </div>
    </>
  );
};

SearchInputComponent.propTypes = {
  onOnlyOwnerChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onSearchingTermChange: PropTypes.func.isRequired,
  searchingTerm: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
};

export const SearchInput = memo(SearchInputComponent);
